const changeAvatar = async (_url: string): Promise<boolean> => {
	return true;
};

export default changeAvatar;
